<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>
<script>
  import localization_keys from '../localization_keys'
  import { mapState, mapMutations } from 'vuex'
  import languages from './utils/languages'

  export default {
    beforeMount() {
      let initial_keys = JSON.parse(JSON.stringify(localization_keys));
      let lang_from_cookie = this.getCookie('hk_language') || process.env.VUE_APP_LANGUAGE_CODE
      let initial_locale = this.$route.query.hasOwnProperty('fromBooking') ? initial_keys.find(code => code.lang_code === lang_from_cookie) :
        initial_keys.find(code => code.lang_code === process.env.VUE_APP_LANGUAGE_CODE)
      let initial_code = initial_locale.lang_code.substring(0, 2)
      let all_languages = JSON.parse(JSON.stringify(languages));
      let seleceted_language = all_languages[initial_code]

      this.SET_LANGUAGE_CODE({ name: seleceted_language.nativeName, code: initial_locale.lang_code })
      this.$i18n.locale = initial_code
      this.$i18n.setLocaleMessage(initial_code, initial_locale.keys);
    },
    computed: {
      ...mapState({
        language: state => state.language_code
      })
    },
    methods: {
      ...mapMutations({
        SET_LANGUAGE_CODE: 'setLanguageCode'
      }),
      getCookie(name) {
        return document.cookie.split('; ').reduce((accumulator, currentValue) => {
          const parts = currentValue.split('=')
          return parts[0] === name ? decodeURIComponent(parts[1]) : accumulator
        }, null)
      }
    }
  };
</script>
